import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResbuildmngFincanceMedic extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)
            console.log("********************");
            console.log(props.resBuildmngFinanceMedic);
            console.log("*************************");

            this.state = {
                  resBuildmngFinanceMedic: this.props.resBuildmngFinanceMedic,
                  // selectedElevatorKinddoor : {
                  //       value: this.props.elevatorDisc.elevator_price_covarage_elevator_kinddoor_id,
                  //       label: this.props.elevatorDisc.elevator_kinddoor_name,
                  // },
                  selectedresBuildmngFinanceMedic: {
                        value: this.props.resBuildmngFinanceMedic.resbuildmng_financemedic_id,
                        label: this.props.resBuildmngFinanceMedic.resbuildmng_financemedic_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  // optionElevatorKinddoor : [],
                  optionElevatorCoverage: [],
                  // elevator_price_coverage_from_person : "",
                  // elevator_price_coverage_to_person : ""

            }
      }
      componentDidMount() {
            this.getoptionFinancemedic()
      }
      getoptionFinancemedic = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_financemedic_id, label: arr.data[k].resbuildmng_financemedic_name })
                              }
                              self.setState({ optionFinancemedic: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_financemedic")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }





      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }
      handleChangeFromUnit = (event) => {
            var temparray = this.state.resBuildmngFinanceMedic
            temparray.resbuildmng_price_financemedic_from_unit = event
            this.setState({ resBuildmngFinanceMedic: temparray })
      }
      handleChangeToUnit = (event) => {
            var temparray = this.state.resBuildmngFinanceMedic
            temparray.resbuildmng_price_financemedic_to_unit = event
            this.setState({ resBuildmngFinanceMedic: temparray })
      }
      handleChangeAmount = (event) => {
            var temparray = this.state.resBuildmngFinanceMedic
            temparray.resbuildmng_price_financemedic_amount = event
            this.setState({ resBuildmngFinanceMedic: temparray })
      }
      handleFinancemedic = (selectedresBuildmngFinanceMedic) => {
            var temparray = this.state.resBuildmngFinanceMedic
            temparray.resbuildmng_price_financemedic_resbuildmng_financemedic_id = selectedresBuildmngFinanceMedic.value
            this.setState({ selectedresBuildmngFinanceMedic: selectedresBuildmngFinanceMedic, resBuildmngFinanceMedic: temparray })
      }



      modifyNewInstalmentCondition = () => {
            const { resBuildmngFinanceMedic } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_finance_medic")
            fd.append("resbuildmng_price_financemedic_id", resBuildmngFinanceMedic.resbuildmng_price_financemedic_id)
            fd.append("resbuildmng_price_financemedic_resbuildmng_financemedic_id", resBuildmngFinanceMedic.resbuildmng_price_financemedic_resbuildmng_financemedic_id)
            fd.append("resbuildmng_price_financemedic_from_unit", resBuildmngFinanceMedic.resbuildmng_price_financemedic_from_unit)
            fd.append("resbuildmng_price_financemedic_to_unit", resBuildmngFinanceMedic.resbuildmng_price_financemedic_to_unit)
            fd.append("resbuildmng_price_financemedic_amount", resBuildmngFinanceMedic.resbuildmng_price_financemedic_amount)

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { resBuildmngFinanceMedic } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_finance_medic")
            fd.append("resbuildmng_price_financemedic_id", resBuildmngFinanceMedic.resbuildmng_price_financemedic_id)

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {  snackMode, snackstr, showSnack, visible,resBuildmngFinanceMedic , optionFinancemedic, selectedresBuildmngFinanceMedic} = this.state

            if (visible) {
                  return (
                      <Grid container spacing={3}>
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>

                            {/*<Grid item xs={3}>*/}
                            {/*      <div>*/}
                            {/*            <label className="on">پوشش بیمه نامه </label>*/}
                            {/*            <Select*/}
                            {/*                isSearchable={true}*/}
                            {/*                className="adapter-txtsize"*/}
                            {/*                placeholder={"پوشش بیمه نامه"}*/}
                            {/*                value={selectedresBuildmngFinanceMedic}*/}
                            {/*                onChange={this.handleElevatorCoverage }*/}
                            {/*                options={optionElevatorCoverage}*/}
                            {/*            />*/}
                            {/*      </div>*/}
                            {/*</Grid>*/}

                            {/*<Grid item xs={3}>*/}
                            {/*      <div>*/}
                            {/*            <label className="on">نوع درب </label>*/}
                            {/*            <Select*/}
                            {/*                isSearchable={true}*/}
                            {/*                className="adapter-txtsize"*/}
                            {/*                placeholder={"نوع درب"}*/}
                            {/*                value={selectedElevatorKinddoor }*/}
                            {/*                onChange={this.handleElevatorKinddoor  }*/}
                            {/*                options={optionElevatorKinddoor }*/}
                            {/*            />*/}
                            {/*      </div>*/}
                            {/*</Grid>*/}



                            {/*<Grid item xs={3}>*/}
                            {/*      <FloatingLabelInput*/}
                            {/*          type="currency"*/}
                            {/*          placeholder=" قیمت بیمه نامه"*/}
                            {/*          handleInputt={this.handleChangeCovaragePrice}*/}
                            {/*          value={resBuildmngFinanceMedic.elevator_price_covarage_price}*/}
                            {/*      />*/}
                            {/*</Grid>*/}

                            <Grid item item xs={2}>
                                  <FloatingLabelInput
                                      type="number"
                                      placeholder="از تعداد واحد "
                                      handleInputt={this.handleChangeFromUnit}
                                      value={resBuildmngFinanceMedic.resbuildmng_price_financemedic_from_unit}
                                  />
                            </Grid>
                            <Grid item item xs={2}>
                                  <FloatingLabelInput
                                      type="number"
                                      placeholder=" تا تعداد واحد "
                                      handleInputt={this.handleChangeToUnit}
                                      value={resBuildmngFinanceMedic.resbuildmng_price_financemedic_to_unit}
                                  />
                            </Grid>

                            <Grid item xs={3}>
                                  <div>
                                        <label className="on"> پوشش مالی پزشکی </label>
                                        <Select
                                            isSearchable={true}
                                            className="adapter-txtsize"
                                            placeholder={"پوشش مالی پزشکی"}
                                            value={selectedresBuildmngFinanceMedic}
                                            onChange={this.handleFinancemedic}
                                            options={optionFinancemedic}
                                        />
                                  </div>
                            </Grid>



                            <Grid item item xs={2}>
                                  <FloatingLabelInput
                                      type="currency"
                                      placeholder=" قیمت بیمه نامه "
                                      handleInputt={this.handleChangeAmount}
                                      value={resBuildmngFinanceMedic.resbuildmng_price_financemedic_amount}
                                  />
                            </Grid>

                            <Grid item xs={3}>
                                  <div style={{ width: "100%", textAlign: "left" }}>
                                        <Fab
                                            className={classes.small}
                                            style={{ background: "#44b700" }}
                                            aria-label="edit"
                                            onClick={this.modifyNewInstalmentCondition}
                                        >
                                              <EditIcon />
                                        </Fab>

                                        <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                              <DeleteIcon />
                                        </Fab>
                                  </div>
                            </Grid>
                            <Grid item xs={12}>
                                  <Divider />
                            </Grid>
                      </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResbuildmngFincanceMedic)
